/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Table_Offerid2Inputs */

const id_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Penawaran`)
};

const ms_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Tawaran`)
};

const da_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbuds-ID`)
};

const de_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Angebots-ID`)
};

const en_us2_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offer ID`)
};

const es_es2_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de oferta de catálogo`)
};

const es_mx2_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de oferta`)
};

const fil_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ng Offer`)
};

const fr_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID d'offre`)
};

const it_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID offerta`)
};

const hu_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajánlat azonosító`)
};

const nl_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aanbod-ID`)
};

const no_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tilbuds-ID`)
};

const pl_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID oferty`)
};

const pt_br2_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da oferta de catálogo`)
};

const pt_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID da oferta`)
};

const ro_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ofertă`)
};

const fi_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tarjouksen tunnus`)
};

const sv_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erbjudande-ID`)
};

const vi_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID Ưu đãi`)
};

const tr_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teklif ID`)
};

const cs_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID nabídky`)
};

const bg_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID на оферта`)
};

const ru_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID предложения`)
};

const uk_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID пропозиції`)
};

const ar_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معرف العرض`)
};

const hi_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ऑफ़र ID`)
};

const th_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID ข้อเสนอ`)
};

const ja_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`オファーID`)
};

const zh_cn2_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目录项ID`)
};

const zh_hant1_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`目錄項目ID`)
};

const ko_offerdetail_table_offerid2 = /** @type {(inputs: Offerdetail_Table_Offerid2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`오퍼 ID`)
};

/**
* | output |
* | --- |
* | "Offer ID" |
*
* @param {Offerdetail_Table_Offerid2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_table_offerid2 = /** @type {((inputs?: Offerdetail_Table_Offerid2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Table_Offerid2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_table_offerid2(inputs)
	if (locale === "ms") return ms_offerdetail_table_offerid2(inputs)
	if (locale === "da") return da_offerdetail_table_offerid2(inputs)
	if (locale === "de") return de_offerdetail_table_offerid2(inputs)
	if (locale === "en-US") return en_us2_offerdetail_table_offerid2(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_table_offerid2(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_table_offerid2(inputs)
	if (locale === "fil") return fil_offerdetail_table_offerid2(inputs)
	if (locale === "fr") return fr_offerdetail_table_offerid2(inputs)
	if (locale === "it") return it_offerdetail_table_offerid2(inputs)
	if (locale === "hu") return hu_offerdetail_table_offerid2(inputs)
	if (locale === "nl") return nl_offerdetail_table_offerid2(inputs)
	if (locale === "no") return no_offerdetail_table_offerid2(inputs)
	if (locale === "pl") return pl_offerdetail_table_offerid2(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_table_offerid2(inputs)
	if (locale === "pt") return pt_offerdetail_table_offerid2(inputs)
	if (locale === "ro") return ro_offerdetail_table_offerid2(inputs)
	if (locale === "fi") return fi_offerdetail_table_offerid2(inputs)
	if (locale === "sv") return sv_offerdetail_table_offerid2(inputs)
	if (locale === "vi") return vi_offerdetail_table_offerid2(inputs)
	if (locale === "tr") return tr_offerdetail_table_offerid2(inputs)
	if (locale === "cs") return cs_offerdetail_table_offerid2(inputs)
	if (locale === "bg") return bg_offerdetail_table_offerid2(inputs)
	if (locale === "ru") return ru_offerdetail_table_offerid2(inputs)
	if (locale === "uk") return uk_offerdetail_table_offerid2(inputs)
	if (locale === "ar") return ar_offerdetail_table_offerid2(inputs)
	if (locale === "hi") return hi_offerdetail_table_offerid2(inputs)
	if (locale === "th") return th_offerdetail_table_offerid2(inputs)
	if (locale === "ja") return ja_offerdetail_table_offerid2(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_table_offerid2(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_table_offerid2(inputs)
	return ko_offerdetail_table_offerid2(inputs)
});
export { offerdetail_table_offerid2 as "offerDetail.table.offerId" }